import Vue from 'vue';
import Vuex from 'vuex';

import { state } from './state';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

import { findPartners } from './modules/findPartners';
import { managePartners } from './modules/managePartners';
import { managePartnersDetail } from './modules/managePartnersDetail';
import { managePartnersInvitation } from './modules/managePartnersInvitation';
import { ourPublicProfiles } from './modules/ourPublicProfiles';
import { ourPublicProfilesDetail } from './modules/ourPublicProfilesDetail';
import { ourPublicProfilesLeads } from './modules/ourPublicProfilesLeads';
import { sendInvitations } from './modules/sendInvitations';
import { directorySettings } from './modules/directorySettings';
import { ourPublicProfilesShowcases } from './modules/ourPublicProfilesShowcases';
import { userAccount } from './../userAccount';
import { matchmakingRequests } from './modules/matchmakingRequests';

Vue.use(Vuex);

export default {
  state,
  getters,
  mutations,
  actions,
  modules: {
    findPartners,
    managePartners,
    managePartnersDetail,
    managePartnersInvitation,
    ourPublicProfiles,
    ourPublicProfilesDetail,
    ourPublicProfilesLeads,
    sendInvitations,
    directorySettings,
    ourPublicProfilesShowcases,
    userAccount,
    matchmakingRequests,
  },
};
